module.exports = __webpack_public_path__ + "img/portadaCotizacion.09beeb46.jpg";